import { useParams } from "react-router-dom";
import { EdbProvider } from "./form/context/EdbContext";
import EDBProfileContent from "./ProfileEDB/ProfileEDBContent";
import { ProfileEDBProvider } from "./ProfileEDB/context/ProfileEDBContext";

interface RouteParams {
  idEdb: string;
}

function EDBProfile() {
  const { idEdb } = useParams<RouteParams>();
  return (
    <EdbProvider>
      <ProfileEDBProvider idEdb={idEdb}>
        <EDBProfileContent />
      </ProfileEDBProvider>
    </EdbProvider>
  );
}

export default EDBProfile;
